const PARAGRAPH_FREE_TEXT = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
    ... on FreeText {
      id
      body
      type
      uuid
    }
  }
`;

export default PARAGRAPH_FREE_TEXT;
